var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createDashboard, updateDashboard } from 'app/store/reducers/dashboards';
import { fetchAllSteps } from 'app/store/reducers/steps';
import { fetchAllGroups } from 'app/store/reducers/groups';
import { reduxStepsSelector } from 'app/store/selectors/steps';
import { groupsSelector } from 'app/store/selectors/groups';
import FormData from 'app/components/Form/FormData/FormData.jsx';
import { ModalConfirmForm } from 'app/components/Modal';
import formFields from 'app/pages/Project/Settings/Dashboards/ModalEditDashboard/formFields';
const ModalEditDashboard = (_a) => {
    var { projectId, dashboard } = _a, modalprops = __rest(_a, ["projectId", "dashboard"]);
    const dispatch = useDispatch();
    const history = useHistory();
    const steps = useSelector(reduxStepsSelector);
    const groups = useSelector(groupsSelector);
    const stepsOptions = steps.map((step) => ({ label: step.name, value: step.id }));
    const groupsOptions = groups.map((group) => ({ label: group.name, value: group.id }));
    const fields = formFields({ stepsOptions, groupsOptions });
    const handleEditDashboard = (data) => __awaiter(void 0, void 0, void 0, function* () {
        const { name, step, group, supervisorGroup } = data;
        const newDashboard = {
            config: {},
            project: projectId,
            name,
            step,
            group,
            supervisorGroup,
        };
        const res = yield dispatch((dashboard === null || dashboard === void 0 ? void 0 : dashboard.id) ? updateDashboard(Object.assign({ id: dashboard.id }, newDashboard)) : createDashboard(newDashboard));
        return res;
    });
    useEffect(() => {
        dispatch(fetchAllSteps());
        dispatch(fetchAllGroups());
    }, []);
    return (_jsx(ModalConfirmForm, Object.assign({ draggable: false, title: (dashboard === null || dashboard === void 0 ? void 0 : dashboard.id) ? 'Edit dashboard' : 'Create a new dashboard', validateLabel: "Save" }, modalprops, { children: _jsx(FormData, { onSave: (data) => __awaiter(void 0, void 0, void 0, function* () {
                const res = yield handleEditDashboard(data);
                // @ts-ignore
                history.push(`/projects/${projectId}/settings/dashboards/${res.payload.id}`);
                return res;
            }), defaultData: {
                name: dashboard === null || dashboard === void 0 ? void 0 : dashboard.name,
                step: dashboard === null || dashboard === void 0 ? void 0 : dashboard.step,
                group: dashboard === null || dashboard === void 0 ? void 0 : dashboard.group,
                supervisorGroup: dashboard === null || dashboard === void 0 ? void 0 : dashboard.supervisorGroup,
            }, properties: fields, flashNotifSuccessLabel: `Dashboard ${(dashboard === null || dashboard === void 0 ? void 0 : dashboard.id) ? 'updated' : 'created'}` }) })));
};
export default ModalEditDashboard;
